/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UpdateUserProjectCodesRequest} from '../models/UpdateUserProjectCodesRequest';
import type {UserProjectCode} from '../models/UserProjectCode';

export interface GetUserProjectCodes$Request {
    userId: number;
}

export interface GetUserProjectCodes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserProjectCodesRequest = createAction<PayloadData<void, GetUserProjectCodes$Request>>('USER_PROJECT_CODES__GET_USER_PROJECT_CODES__REQUEST');
export const getUserProjectCodesSuccess = createAction<PayloadData<Array<UserProjectCode>, GetUserProjectCodes$Request>>('USER_PROJECT_CODES__GET_USER_PROJECT_CODES__SUCCESS');
export const getUserProjectCodesFailure = createAction<PayloadData<Error, GetUserProjectCodes$Request, true>>('USER_PROJECT_CODES__GET_USER_PROJECT_CODES__FAILURE');

export const getUserProjectCodesActions = [
    getUserProjectCodesRequest,
    getUserProjectCodesSuccess,
    getUserProjectCodesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserProjectCodes = (meta: GetUserProjectCodes$Request, config?: GetUserProjectCodes$Config) => {
    return {
        CALL_API: {
            types: getUserProjectCodesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/project-codes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateUserProjectCodes$Request {
    userId: number;
    updateUserProjectCodesRequest: UpdateUserProjectCodesRequest;
}

export interface UpdateUserProjectCodes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserProjectCodesRequest = createAction<PayloadData<void, UpdateUserProjectCodes$Request>>('USER_PROJECT_CODES__UPDATE_USER_PROJECT_CODES__REQUEST');
export const updateUserProjectCodesSuccess = createAction<PayloadData<void, UpdateUserProjectCodes$Request>>('USER_PROJECT_CODES__UPDATE_USER_PROJECT_CODES__SUCCESS');
export const updateUserProjectCodesFailure = createAction<PayloadData<Error, UpdateUserProjectCodes$Request, true>>('USER_PROJECT_CODES__UPDATE_USER_PROJECT_CODES__FAILURE');

export const updateUserProjectCodesActions = [
    updateUserProjectCodesRequest,
    updateUserProjectCodesSuccess,
    updateUserProjectCodesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UpdateUserProjectCodesRequest} meta.updateUserProjectCodesRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserProjectCodes = (meta: UpdateUserProjectCodes$Request, config?: UpdateUserProjectCodes$Config) => {
    return {
        CALL_API: {
            types: updateUserProjectCodesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/project-codes`,
            TRANSPORT_REQUEST_BODY: meta.updateUserProjectCodesRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

